<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_scr_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label :label="$t('MSG_TXT_TRM_NM')" :vertical="false" />
        </div>
        <div class="col-xs-3">
          <sui-text-field placeholder="" v-model="searchWord" :disabled="false" @keyup.enter="retrievalList" :readonly="false"></sui-text-field>
        </div>
        <div class="btn_wrap">
          <sui-button type="button" class="comm_btn_Reset" @click="resetSearch()" v-permission:read="'PGE_CMT_00004'"> {{$t('MSG_BTN_RESET')}}</sui-button>
          <sui-button type="button" class="comm_btn_Scr" @click="retrievalList()" v-permission:read="'PGE_CMT_00004'"> {{$t('MSG_BTN_SRCH')}}</sui-button>
        </div>
      </div>
    </div>
    <div class="comm_shut_wrap">
      <div class="inbox">
        <div class="comm_title_wrap">
          <h4>{{$t('MSG_TIT_WRD_QRY_LIST')}}</h4>
        </div>
        <div class="mrB10"></div>
        <sui-grid ref="grid" :columns="gridColumns0" :dataset="'dataset0'"
              :hideHeader="false"
              :autoheight= "false"
              :multiselect="true"
              :pageable="false"
              :showCountControl="true"
              :showDisplayCountControl="false"
              
              >
              <!--<div class="comm_line_div" />
              <div class="btn_wrapL">
                <sui-button type="button" class="comm_btn_gridTop" @click="deleteRow()">{{$t('MSG_BTN_ROW_DEL')}}</sui-button>
              </div>-->
        </sui-grid>
      </div>
      <div class="emptybox"></div>
      <div class="inbox">
        <div class="comm_title_wrap">
          <h4>{{$t('MSG_TXT_DOMAIN_NAME')}}</h4>
        </div>
        <div class="mrB10"></div>
        <sui-grid ref="grid1" :columns="gridColumns1" :dataset="'dataset1'"
              :hideHeader="false"
              :autoheight= "false"
              :multiselect="false"
              :pageable="false"
              :showCountControl="true"
              :showDisplayCountControl="false"
              @rowclick="onSelectDomainRow"
              >
              <div class="btn_wrapR">
                <sui-button type="button" class="comm_btn_gridTop" :disabled= "isNewRegistrtion" @click="combinationTerm()">{{$t('MSG_TXT_CMBNT_TRM')}}</sui-button>
                <!-- <sui-button type="button" class="comm_btn_gridTop" :disabled= "isNewRegistrtion" @click="sourceTermClick()">{{$t('MSG_TXT_REF_TRM')}}</sui-button> -->
             </div>
        </sui-grid>
      </div>
    </div>
    <div class="comm_title_wrap">
      <h4>{{$t('MSG_TIT_APPL_TRM')}}</h4>
    </div>
    <sui-grid ref="grid2" :columns="gridColumns2" :dataset="'dataset2'"
          :hideHeader="false"
          :autoheight= "false"
          :multiselect="false"
          :pageable="false"
          :showCountControl="true"
          :showDisplayCountControl="false"
          :initial-pagesize="2"
          :pagesizeoptions="[2]"

          >
    </sui-grid>
    <div class="mrB30"></div>
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label :label="$t('MSG_TXT_MDLE')" :required="true"  :vertical="false" />
        </div>
        <div class="col-xs-5">
          <sui-module-submodule-select ref="moduleTypeOptions"
              :page-id="this.$options.name"
              :selected-md="selectData.moduleCode"
              :selected-smd="selectData.subModuleCode"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
            />
            
        </div>       
         <div class="col-xs-1">
          <sui-input-label :label="$t('MSG_TXT_SRC_TRM_NM')" :vertical="false" />
        </div>
        <div class="col-xs-5">
          <sui-text-field placeholder="" default value v-model="sourceTerm" :disabled="true" @click="sourceTermClick()" :clearable="true" :readonly="false" fixed-icon></sui-text-field>
          <div class="comp_spacing"></div>
          <sui-button type="button" class="btn_innerTbl_border" @click="excludeClick" v-permission:update="'PGE_CMT_00004'"> {{$t('MSG_BTN_EXLD')}}</sui-button>
        </div>
      </div>
      <div class="row">

        <div class="col-xs-1">
          <sui-input-label :label="$t('MSG_TXT_CODE_NAME')" :required="false" :vertical="false" />
        </div>
        <div class="col-xs-5">
          <sui-text-field placeholder="" default value v-model="codeTerm" :disabled="true" :clearable="true" :readonly="false"></sui-text-field>
          <div class="comp_spacing"></div>
          <sui-text-field placeholder="" @click="codeIdFunction()" default value v-model="codeName" :disabled="true" :clearable="true" :readonly="false" fixed-icon ></sui-text-field>
          <div class="comp_spacing" />
          <sui-button type="button" class="comm_btn_Reset" :disabled="codeStatus" @click="onClickCodeRegist()" v-permission:read="'PGE_CMT_00004'">{{$t('MSG_BTN_CODE_RGST')}}</sui-button>
        </div>
        <div class="col-xs-6">
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label :label="$t('MSG_TXT_TRM_DSCR')" :required="true"  :vertical="false" />
        </div>
        <div class="col-xs-11">
          <textarea v-model="termContent"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label :label="$t('MSG_TXT_TRM_EN_DSCR')" :required="false" :vertical="false" />
        </div>
        <div class="col-xs-11">
          <textarea v-model="termContentEn"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label :label="$t('MSG_TXT_APPL_CNTN')" :required="true" :vertical="false" />
        </div>
        <div class="col-xs-11">
          <textarea v-model="termApplyContent"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="comm_btn_wrap mrR30">
    <sui-button type="button" class="comm_btn_border" @click="onPopupCancelClicked">{{$t('MSG_BTN_CLOSE')}}</sui-button>
    <sui-button type="button" class="comm_btn_border" @click="resetFunction" v-permission:read="'PGE_CMT_00004'">{{$t('MSG_BTN_RESET')}}</sui-button>
    <sui-button type="button" class="comm_btn_solid" @click="applyFunction" v-permission:create="'PGE_CMT_00004'">{{$t('MSG_BTN_APPL')}}</sui-button>
  </div>
    <sui-popup v-model="showSourcePopup" :title="$t('MSG_TIT_REF_TRM_LIST')">
      <p05 @exit="onChildPopClicked()" @sourceTermPopulate="sourceTermPopulateMethod"/>
    </sui-popup>
  </div>
</template>
<script>
import p05 from './PGE_CMT_00004_P05';
  export default {
    name: 'PGE_CMT_00004_P01',
    props: {
      parentPageId:{
        type: String,
        default: '',
      },
    },
    components: {
      p05,
    },
    data() {
      return {
        searchWord: '',
        termName: '',
        isNewRegistrtion : true,
        duplicateCheckValue:false,
        codeTerm: '',
        codeTypeName:'',
        codeName:'',
        codeStatus:true,
        sourceTerm:'',
        sourceTermID : '',
        termPhysicalName:'',
        domainDetails:'',
        codeSturctureTypeCode : '',
        codeValidValue :'',
        showMetauserBtn : false,
        biddingInformationParam : {},
        wordDeleteArray: true,
        showSourcePopup:false,
        termApplyContent : '',
        termContentEn: '',
        termContent:'',
        radioStrValue: '',
        arrayalOrder:'',
        dataWithSynonym:[],
        wordListDisplay: [],
        domainList: [],
        selectData: {
          moduleCode: { key: '', label: '' },
          subModuleCode: { key: '', label: '' }
        },
        localdata0: [],
        gridColumns0: [{
          text: this.$t('MSG_TXT_WRD_NM'),
          datafield: 'wordName',
          width: 100,
        }, {
          text: this.$t('MSG_TXT_WRD_PHSC_NM'),
          datafield: 'wordId'
        }, {
          text: this.$t('MSG_TXT_WRD_TYP_NM'),
          datafield: 'wordTypeName',
          width: 100,
        }, {
          text: this.$t('MSG_TXT_STT'),
          datafield: 'wordStatus',
            createwidget: (row, column, value, htmlElement) => {
              if (value != 'EXIST'){
                utils.getGridCellFactory().createCellButton(row, column, this.$t('MSG_TXT_WRD_RGST'), htmlElement, {
                  handler: this.onGridButtonClicked,
                  type: 'button',
                }, this.dataset0, this.$refs.gridList);
              } else{
                value = '';
              }
            },
            initwidget(row, column, value, htmlElement) {
              if (value != 'EXIST'){
                utils.getGridCellFactory().refreshCell(row, column, this.$t('MSG_TXT_WRD_RGST'), htmlElement);
              } else{value = '';}
            },
            width: 100,
        }],
        localdata1: [],
        gridColumns1: [{
          text: this.$t('MSG_TXT_DOMAIN_NAME'),
          datafield: 'domainName'
        }, {
          text: this.$t('MSG_TXT_DT_TYP'),
          datafield: 'domainDataTypeName',
          width: 100,
        }, {
          text: this.$t('MSG_TXT_DOM_CNTN'),
          datafield: 'domainContent'
        }
        ],
        localdata2: [],
        gridColumns2: [{
          text: this.$t('MSG_TXT_TRM_NM'),
          datafield: 'termName'
        }, {
          text: this.$t('MSG_TXT_TRM_PHSC_NM'),
          datafield: 'termId'
        }, {
          text: this.$t('MSG_TXT_TRM_DSCR'),
          datafield: 'termContent'
        },{
          text: this.$t('MSG_TXT_TRM_EN_DSCR'),
          datafield: 'termContentEn'
        }, {
          text: this.$t('MSG_TXT_DOMAIN_NAME'),
          datafield: 'domainName'
        }, {
          text: this.$t('MSG_TXT_DT_TYP'),
          datafield: 'dataType',
          width: 100,
        }, {
          text: this.$t('MSG_TXT_LEN'),
          datafield: 'length',
          width: 80,
        }, {
          text: this.$t('MSG_TXT_DECM_LGHT'),
          datafield: 'pointLength',
          width: 100,
        },{
          text: this.$t('MSG_BTN_DPCT_CHK'),
          datafield: 'duplicatecheck',
          createwidget: (row, column, value, htmlElement) => {
              utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
                handler: this.onClickDuplicate,
                type: 'Button',
              }, this.dataset2, this.$refs.gridList);
          },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }]
      };
    },
    computed: {},
    watch: {},
    mounted() {
      this.getSession();
    },
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    methods: {
      
      resetSearch(){
        this.searchWord = ''
        let emptyArray=[];
        this.dataset0.setRawData(emptyArray);
        this.dataset1.setRawData(emptyArray);
        this.dataset2.setRawData(emptyArray);
      },
      sourceTermClick(){
        this.showSourcePopup = true;
      },
      //similar word list
      isSynonymWord(data){
        
        let isSynonym = 1;
        data.forEach((element,index) => {
              if(element['wordStatus'] == 'Not Exists'){
            http.request('PGE_CMT_00004', 'DTS_CMT_00090', {
              path: {
                'synonym': element['wordName'],
              },
            })
            .then(res => {
              isSynonym++;
              if(res.data.length > 0){
                console.log('checking syn-----')
                element['wordName'] = res.data[0]['wordName'];
                element['wordId'] = res.data[0]['wordId'];
                element['wordTypeName'] = res.data[0]['wordTypeName'];
                element['wordStatus'] = 'EXIST';
                this.wordListDisplay = data;
                this.dataWithSynonym.push(element);
                this.dataset0.setRawData(data);
                //this.dataset0.setRawData(this.dataWithSynonym);
              }
              else {
                this.dataWithSynonym.push(element);
              }
            
            });
            
          } 
 
        });
        setTimeout(()=>{this.dataset0.setRawData(data)}, 200);
        this.wordListDisplay=data;
        
      },
      //Term API
      retrievalList(){
        this.dataset0.setRawData([]);
        this.dataset2.setRawData([]);
        let counter =0
        this.isNewRegistrtion = true;
        http.request('PGE_CMT_00004', 'DTS_CMT_00032', {
          query:{
            termName: this.searchWord,
          } 
        }).then(res => {
          this.wordListDisplay = res.data;
          if(res.data.length > 1){
            this.isSynonymWord(res.data);
            
            //console.log(this.dataWithSynonym)
            
            this.isClassificationWord(res.data);
            //validation for combination buuton
            
          } else{
            utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CMBNT_WRD_CNT'), null))
          }
       })
        console.log('final value :' + counter);
        
      },
      // check domain type is classification word or not
      isClassificationWord(data){
        let unregisteredCount=0;
        let lastData = data.length - 1;
        //enabling code id if last word is code
        if( data[lastData].wordName.toUpperCase()=='CODE' || data[lastData].wordName.toUpperCase()=='코드' ){
          this.codeStatus=false;
        } else {this.codeStatus=true;} 
        //condition classification word last word
        if(data[lastData]['wordTypeCode'] =='1'){
          http.request('PGE_CMT_00004', 'DTS_CMT_00086', {
            path: {
              'word-id': data[lastData]['wordId'],
            },
          }).then(res => {
            this.dataset1.setRawData(res.data);
          })
        } else{
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_FNL_WRD_CLSF'), null))
          this.dataset0.setRawData([]);
        }
        //validation for combination button
        this.wordListDisplay.forEach(element => { 
            if(element['wordStatus'] != 'EXIST'){
              unregisteredCount++;
            }
          });
          if(unregisteredCount > 0)
          {
            this.isNewRegistrtion=true;
          }
          else{
            this.isNewRegistrtion=false;
          }
      },
      // get session    
      getSession() {
        
        console.log(utils.hasRoleNickName('DTA_STD_ADMIN'));

      },
      // duplicate check
      onClickDuplicate(){
          let queryParams = {
            termId: this.termPhysicalName,
            termName: this.termName
          }
          http.request('PGE_CMT_00004', 'DTS_CMT_00027', {
            query:queryParams
          }).then(res => { 
            if(res.data == 0) {
              this.duplicateCheckValue = true;
              const msg = utils.strFormat(this.$t('MSG_ALT_BE_RGST_OK'), this.$t('MSG_TXT_TRM_NM'));
              utils.messageBox('information', msg);
            }else {
              utils.messageBox('warning', this.$t('MSG_ALT_IS_EXISTS'), null, null);
            }
          })
      },
      //exclude button
      excludeClick(){
        this.sourceTerm = '';
      },
      // on select row
      onSelectRow(target){
        // let wordArray = this.wordListDisplay;
        // let order = target.args.row.arrayalOrder;
        // this.wordListDisplay  = this.wordListDisplay.filter( function(obj){
        //   if(obj.arrayalOrder == order){
        //     wordArray.splice(wordArray.indexOf(obj), 1);
        //   };
        //   return obj.arrayalOrder != order;
        // });
        // this.wordListDisplay  = wordArray;
      },
      // on unselect row
      onUnselectRow(target){
        // let wordArray = this.wordListDisplay;
        // let order = target.args.row.arrayalOrder;
        // this.wordListDisplay  = this.wordListDisplay.filter( function(obj){
        //   if(obj.arrayalOrder == order){
        //     wordArray.push(obj);
        //   };
        //   return obj.arrayalOrder != order;
        // });
        // this.wordListDisplay  = wordArray;
      },
      // domain row selection
      onSelectDomainRow(target){
          this.isNewRegistrtion = false;
          this.wordListDisplay.forEach(element => { 
            if(element['wordStatus'] != 'EXIST'){ this.isNewRegistrtion = true; }
          });

      },
      onChildPopClicked(){
        this.showSourcePopup = false;
      },
      // combition of term 
      combinationTerm(){
        const selectedIndexes = this.dataset1.getSelectedIndexes();
       
        this.domainDetails = this.dataset1.data[selectedIndexes];
        if( !this.domainDetails)
        {
          utils.messageBox('warning',utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'),this.$t('MSG_TXT_DOMAIN_NAME')))
        }
        else {
          let termWordName = '';
          let termPhysicalName = '';
          let termPhysicalCheck = true;
          let firstDomain = true;
          this.wordListDisplay.forEach(element => {
          
          if(element['wordName']){
            if(termWordName){
              termWordName = termWordName + element['wordName'];
            } else{
              termWordName = element['wordName'];
            }
          }

          if(element['wordId']){
            if(termPhysicalName){
              termPhysicalName = termPhysicalName + '_' + element['wordId'];
              if(String(termPhysicalName).length > 27){
                utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_TRM_LEN_CHK') , null));
                termPhysicalCheck = false;
                //this.dataset2.data = [];
              }
            } else{
              termPhysicalName = element['wordId'];
            }
          }
        });
        this.termName = termWordName;
        this.termPhysicalName = termPhysicalName;
        
        let combinationTermList = [{
          "termName" : this.termName,
          "termId" : this.termPhysicalName,
          "termContent" : this.termContent,
          "termEnContent" : this.termContentEn,
          "domainName": this.domainDetails.domainName,
          "dataType": this.domainDetails.domainDataTypeName,
          "length": this.domainDetails.domainLength,
          "pointLength": this.domainDetails.domainDataDecimalLength,
          "duplicatecheck" : this.$t('MSG_BTN_DPCT_CHK')
        }]
        
        this.dataset2.setRawData(combinationTermList);
        
      }
      },
      // delete row 
      deleteRow(){
        const selectedIndexes = this.dataset0.getSelectedIndexes();
        this.dataset0.deleteRows(selectedIndexes);

      },
      // on click row function
      onGridButtonClicked(event , row){ 
        utils.openLayerPopup('PGE_CMT_00003',this.onNewWordClicked,{
        pageInitialData: { content: 'PGE_CMT_00004', value:true , wordName: row.wordName},
        size: 'xlg'})
      },
      resetFunction(){
        this.searchWord = '';
        this.termName = '';
        this.sourceTerm = '';
        this.sourceTermID = '' ;
        this.termContent = '';
        this.termContentEn= '';
        this.selectData.moduleCode.key='ALL';
        this.selectData.subModuleCode.key='ALL';

        this.termApplyContent = '';
        this.codeTerm = '';
        this.codeName = '';
        let emptyArray=[];
        this.dataset0.setRawData(emptyArray);
        this.dataset1.setRawData(emptyArray);
        this.dataset2.setRawData(emptyArray);
      },
      //code Id Function
      codeIdFunction(){

        if (!this.isAllowCode()) return ;
        utils.openLayerPopup('PGE_CMZ_00003',this.onPagePopupCallback,{
          pageInitialData: { content: this.$options.name, value:true , wordName: this.wordName},
          size: 'lg'
        })
      },
      isAllowCode(){
        var wflag = false ;
        var wordList = this.dataset0.data; 
        if (wordList.length <= 0 ) return wflag ;

        var word_lastrow = wordList.length - 1 ; 
        console.log( "TEST wordID " + wordList[word_lastrow]['wordId'])
        if ( wordList[word_lastrow]['wordId'] == 'CD' ){
          wflag = true; 
          return wflag ;
        }

        return wflag ;
      },
      onClickCodeRegist(){
        let url = '';
        let pageId = 'PGE_CMZ_00001';
        url = `${window.location.origin}${window.location.pathname}#/${pageId}`;
        const win = window.open();
        win.location = url;
      },
      //onNewWordClicked(){ this.$emit('exit',true);},
      // CODE ID CALLBACK
      onPagePopupCallback(value){
        if(value){
          this.codeTerm = value[0].codeId,
          this.codeValidValue = value[0].codePhyName
          this.codeName= value[0].codeName
        }
        //this.onPopupCancelClicked();
      },
      applyFunction(){
        if(!this.duplicateCheckValue){
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_DUP'), null,null ) ); 
          return ;
        }//making codeId mandate for term code
        else if(this.codeStatus !=true && this.codeTerm ===''){

          utils.messageBox('warning', utils.strFormat( this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_CODE_NAME'),null));  

          return ;
        }else if(!this.termContent.trim()){
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_TRM_DSCR'),null));  
          return ;
        }
        
        else if(!this.termApplyContent.trim()){
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_APPL_CNTN'),null));
          return ;
        }else if(this.selectData.moduleCode.key ==='ALL'){
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_MDLE'),null)); 
          return ;
        }
        else if(this.selectData.subModuleCode.key ==='ALL' ){
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_SMDLE'),null)); 
          return ;
        }
        else{
          utils.messageBox('confirm', this.$t('MSG_ALT_REQ_PRCD'), null, this.confirmRouter); 

        }
      },
      confirmRouter(){
        if(utils.isEqual(utils.getConfigurationValue('CFG_CMT_KNOX_APRV_YN'),'Y')){
          this.personInChargeList();
        }else {
          this.submitRequestApi();
        }
      },
      submitRequestApi(approvalData){
        let arrayalOrder = 0;
        let wordRelationData = [];
        for(let key in this.wordListDisplay){
          this.arrayalOrder++;
          let data = {
            "arrayalOrder": this.arrayalOrder,
            "termsId": this.termPhysicalName,
            "wordId": this.wordListDisplay[key]['wordId']
          }
          wordRelationData.push(data);
        }
        let queryParams = {  
            "applicantID": this.$store.getters.userInfo.knoxId,
            "codeId": this.codeTerm,
            "codeValidValue": this.codeValidValue,
            "domainDataDecimalLength": this.domainDetails.domainDataDecimalLength,
            "domainDataTypeCode": "0",
            "domainDecription": this.domainDetails.domainContent,
            "domainLength":  this.domainDetails.domainLength,
            "domainName": this.domainDetails.domainName,
            "domainPhysicalName": this.domainDetails.domainId,
            "moduleCode":this.$refs.moduleTypeOptions.selected.md.codeId || '',
            "subModuleCode":this.$refs.moduleTypeOptions.selected.smd.codeId || '',
            //"moduleCode":this.selectData.moduleCode.key,
            "sourceTerm": this.sourceTerm,
            "sourceTermID" : this.sourceTermID,
            //"subModuleCode": this.selectData.subModuleCode.key,
            "termsApplicationContent": this.termApplyContent,
            "termsContent":  this.termContent,
            "termsContentEn":  this.termContentEn,
            "termsId": this.termPhysicalName,
            "termsName": this.termName,
            "wordRelationList": wordRelationData,
            "approvalData": null,
        }

        // 결재 상신 정보가 있으면 결재상신 정보 병합.
        if (!utils.isEmpty(approvalData)) {
          utils.assign(queryParams, { approvalData: approvalData });
        }
       
        http.request('PGE_CMT_00004', 'DTS_CMT_00020', {
          data: queryParams,
        }).then((res) => {
            if(res.data.resultCode ==  '1'){
              this.conFirm('success', this.$t('MSG_ALT_PRGS_OK'), null);
            }else{
              this.conFirm('warning', this.$t('MSG_ALT_IS_EXISTS_APPL'), null);
            }
            this.onPopupCancelClicked();
        })
      },
      onPopupCancelClicked(value) {
         this.$emit('exit',true);
      },
      conFirm(type, value, subValue) {
        utils.messageBox(type, value, subValue, this.onClose);
      },
      sourceTermPopulateMethod(value) {
        let termPhyName = this.termPhysicalName;
        let sourceTermName = value.termName;
        console.log(value);
        let combinationTermList = [{
          "termName" : this.termName,
          "termId" : this.termPhysicalName,
          "domainName": value.domainName,
          "dataType": value.domainDataTypeName,
          "length": value.domainLength,
          "pointLength": value.domainDataDecimalLength,
          "duplicatecheck" : this.$t('MSG_BTN_DPCT_CHK')
        }]

        this.domainDetails.domainName = combinationTermList[0].domainName;
        this.domainDetails.domainDataTypeName = combinationTermList[0].dataType;
        this.domainDetails.domainLength = combinationTermList[0].length;
        this.domainDetails.domainDataDecimalLength = combinationTermList[0].pointLength;
        this.dataset2.setRawData(combinationTermList);
        this.sourceTerm = sourceTermName;
        this.sourceTermID = value.termId;
      },
      
    /**
     * 결재 담당자 조회 및 생성
     */ 
    personInChargeList() {
      http.request(this.parentPageId, 'DTS_CMZ_00136', {
        path: {
          'pic-type-id': 'PIC_CMT_DATA_STD_APRV',
        },
        query: {
        },
      }).then(res => {
        const personInChargeList = [];
        utils.forEach(res.data, obj => {
          const userInfo = {
            userId: obj.userId,
            aprvCode: obj.rightApprovalCode,
          };
          personInChargeList.push(userInfo);
        });
        this.onAprvClick(personInChargeList);
      });
    },
    /*
     * 결재 상신 팝업
     */
    onAprvClick(personInChargeList) {
      const objTemplate = {
        templateId: 'TMP_CMT_APRV_DOC_TRM',
        siteId: this.$store.getters.userInfo.siteId,
        langId: this.$store.getters.userInfo.langId,
        datatStdDivNm: this.$t('MSG_TXT_TRM'),
        datatStdApplDivNm: this.$t('MSG_TXT_NEW'),
        applUserNm: this.$store.getters.userInfo.userName,
        dataStdApplCntn: this.termApplyContent,
        dataStdNm: this.termName,
        dataStdId: this.termPhysicalName,
        domNm: this.domainDetails.domainName, 
        domDataTypeNm: this.domainDetails.domainDataTypeName,
        domDataLght: this.domainDetails.domainLength,
        domDataDecmLght: this.domainDetails.domainDataDecimalLength,
        mdleNm: this.$refs.moduleTypeOptions.selected.md.label,
        smdleNm: this.$refs.moduleTypeOptions.selected.smd.label,
        refTrmNm: this.sourceTerm,
        cdNm: this.codeName,
        dataStdCntn: this.termContent,
        dataStdEnNm: this.termContentEn,
        tcdmDqIfList: [],
      };

      utils.openLayerPopup('PGE_CMZ_00012', this.aprvPopupCallback, {
        pageInitialData: {
          // 필수: 업무코드, 업무결재Id
          taskId: 'TSK_CM006003',
          taskApprovalId: 'uid',

          // 결재 제목
          title: `${this.$t('MSG_TXT_CMT_APRV_PRFX')} ${this.$t('MSG_TXT_TRM')} ${this.$t('MSG_TXT_NEW')} (${this.$t('MSG_TXT_STD_LGC_NM')} : ${this.termName})`,
          titleReadonly: true,

          // 결재 Route
          // 선택:담당자그룹Id로 결재자 조회시 사용
          // picGroupId: 'PIC_CMS_DATA_EXTC',
          aprvUsers: personInChargeList,
          popupRoutesModify: false,
          knoxRoutesModify: false,

          // 선택: 첨부파일 DocId
          // attachDocumentId: [],
          //* 결제에 첨부파일을 등록할경우 모듈 코드 값이 필수
          // moduleCode: 'CM',

          attachModify: false,
          // 결재본문
          objTemplate,
          contentsModify: false,

        },
        size: 'xlg',
      });
    },
    
    /*
     * 결재 상신 팝업 callback
     */
    aprvPopupCallback(objAprv) {
      if (utils.isEmpty(objAprv) === false) {
        this.submitRequestApi(objAprv);
      }
    },    
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [{
        name: 'wordName',
        type: 'string',
        map: 'wordName'
      }, {
        name: 'wordId',
        type: 'string',
        map: 'wordId'
      }, {
        name: 'wordTypeName',
        type: 'string',
        map: 'wordTypeName'
      }, {
        name: 'wordStatus',
        type: 'string',
        map: 'wordStatus'
      }, {
        name: 'arrayalOrder',
        type: 'string',
        map: 'arrayalOrder'
      }]
      }, {
      id: 'dataset1',
      type: 'local',
      data: 'localdata1',
      datafields: [{
        name: 'domainName',
        type: 'string',
        map: 'domainName'
      }, {
        name: 'domainDataTypeName',
        type: 'string',
        map: 'domainDataTypeName'
      }, {
        name: 'domainContent',
        type: 'string',
        map: 'domainContent'
      },
      {
        name: 'domainLength',
        type: 'string',
        map: 'domainLength'
      },
      {
        name: 'domainDataDecimalLength',
        type: 'string',
        map: 'domainDataDecimalLength'
      },{
        name: 'domainId',
        type: 'string',
        map: 'domainId'
      }
      ]
      }, {
      id: 'dataset2',
      type: 'local',
      data: 'localdata2',
      datafields: [{
        name: 'termName',
        type: 'string',
        map: 'termName'
      }, {
        name: 'termId',
        type: 'string',
        map: 'termId'
      }, {
        name: 'termContent',
        type: 'string',
        map: 'termContent'
      },{
        name: 'termContentEn',
        type: 'string',
        map: 'termContentEn'
      },{
        name: 'domainName',
        type: 'string',
        map: 'domainName'
      }, {
        name: 'dataType',
        type: 'string',
        map: 'dataType'
      }, {
        name: 'length',
        type: 'string',
        map: 'length'
      }, {
        name: 'pointLength',
        type: 'string',
        map: 'pointLength'
      }, {
        name: 'duplicatecheck',
        type: 'string',
        map: 'duplicatecheck'
      }]
    }]
  };
</script>
<style scoped>
</style>
